module.exports = __webpack_public_path__ + "static/box3-b7151137ea149cc7307a641e1a17c054.jpg";